import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDataProvider, useGetRecordId } from "react-admin";

export const MemberList = () => {
  const dataProvider = useDataProvider();
  const groupId = useGetRecordId();
  const [members, setMembers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const path = `groups/${groupId}/members`;

  useEffect(() => {
    dataProvider
      .getList(path, {
        filter: {},
        pagination: { page: 1, perPage: 10 },
        sort: { field: "name", order: "ASC" },
      })
      .then(({ data }) => {
        setMembers(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [dataProvider, groupId, path]);

  if (loading) {
    return <Typography variant="body2">加载中...</Typography>;
  }

  if (members.length === 0) {
    return <Typography variant="body2">无组员</Typography>;
  }

  return (
    <Box>
      <Typography variant="body2">组员：</Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>姓名</TableCell>
              <TableCell>用户名</TableCell>
              <TableCell>邮箱</TableCell>
              <TableCell>邮箱验证</TableCell>
              <TableCell>启用</TableCell>
              <TableCell>创建时间</TableCell>
              <TableCell>语言</TableCell>
              <TableCell>所属公司</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {members.map((member: any) => (
              <TableRow key={member.id}>
                <TableCell>{`${member.lastName} ${member.firstName}`}</TableCell>
                <TableCell>{member.username}</TableCell>
                <TableCell>{member.email}</TableCell>
                <TableCell>{member.emailVerified ? "是" : "否"}</TableCell>
                <TableCell>{member.enabled ? "是" : "否"}</TableCell>
                <TableCell>
                  {new Date(member.createdTimestamp).toLocaleString("zh-CN", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                  })}
                </TableCell>
                <TableCell>
                  {member.attributes?.locale?.join(", ") || "无"}
                </TableCell>
                <TableCell>
                  {member.organizations && member.organizations.length > 0 ? (
                    member.organizations.map((org: any) => org.name).join(", ")
                  ) : (
                    <Typography variant="body2" color="error">
                      无组织信息（账号不可用）
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
